// extracted by mini-css-extract-plugin
module.exports = {"container":"aap_e"};